/* eslint-disable react/jsx-no-target-blank */
import { useTranslation } from "react-i18next";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { useFirstLogin } from "../../../../../app/modules/auth/core/TourGuideContext";

const SidebarMenuMain = () => {
  const { t } = useTranslation();

  const { setShowDownloadLinkValue } = useFirstLogin();

  return (
    <>
      <SidebarMenuItem
        title={t("MENU.DASHBOARD")}
        to="/dashboard"
        fontIcon="bi bi-clipboard-data"
      />
      <SidebarMenuItem
        title={t("MENU.CLOUD_DEVICES")}
        to="/devices/list"
        fontIcon="bi-cloud"
      />
      <SidebarMenuItem
        title={t("MENU.DEVICE_BUILDER")}
        to="/device-builder"
        fontIcon="bi bi-stars"
      />
      <SidebarMenuItem
        title={t("MENU.DEVICE_MESSAGE_CENTER")}
        to="/centerDeviceMessage/list"
        fontIcon="bi bi-chat-right-dots"
      />
      <SidebarMenuItem
        title={t("MENU.LABORATORY")}
        to="/laboratory/jsanalyzer"
        fontIcon="fas fa-atom"
      />
      <SidebarMenuItem
        title={t("MENU.LOCATION")}
        to="/location/gps"
        fontIcon="bi bi-pin-map"
      />
      <SidebarMenuItem
        title={t("MENU.SENT_DEVICE_MESSAGES")}
        to="/deviceRequests/sent"
        fontIcon="bi bi-send"
      />
      <SidebarMenuItem
        title={t("MENU.FILE_MANAGER")}
        to="/fileManager/list"
        fontIcon="bi bi-folder2-open"
      />
      <SidebarMenuItem
        title={t("MENU.API_KEY")}
        to="/apiKey/list"
        fontIcon="bi bi-code"
        hasTag={true}
      />
      <SidebarMenuItem
        title={t("MENU.SERVICE_COST")}
        to="/service/list"
        fontIcon="bi bi-cash-stack"
      />
      <SidebarMenuItem
        title={t("MENU.TEST_SOFTWARE_DOWNLOAD")}
        onClick={() => setShowDownloadLinkValue(true)}
        fontIcon="bi bi-download"
        target="_blank"
      />
      <SidebarMenuItem
        title={t("MENU.TRAINING")}
        to="https://docs.airngin.com"
        fontIcon="bi bi-book"
        target="_blank"
      />
      <SidebarMenuItem
        title={t("MENU.SUPPORT")}
        to="/ticket/list"
        fontIcon="bi bi-headset"
      />
    </>
  );
};

export { SidebarMenuMain };
